<a class="skip-link" href="#main">Aller au contenu principal</a>

<app-header
  [pseudo]="data.identity.pseudo"
  [fullName]="data.identity.fullName"
  [navItems]="navItems"
  [isDark]="isDark"
  (toggleTheme)="toggleTheme()"
></app-header>

<main id="main">
  <app-hero [identity]="data.identity" [headline]="data.about.headline"></app-hero>
  <app-about [about]="data.about"></app-about>
  <app-experience [experiences]="data.experiences"></app-experience>
  <app-projects [projects]="data.projects"></app-projects>
  <app-education [education]="data.education"></app-education>
  <app-skills [skills]="data.skills"></app-skills>
  <app-contact [contact]="data.contact"></app-contact>
</main>

<app-footer [fullName]="data.identity.fullName"></app-footer>

<button
  class="back-to-top"
  type="button"
  (click)="scrollToTop()"
  [class.visible]="showBackToTop"
  aria-label="Retour en haut"
>
  ↑
</button>
